@if(!formulaEditing){
<div class="row mb-3 mt-2">
  <div class="col-8 col-md-3">
    <button class="btn btn-secondary text-white m-r-10" (click)="activeChange.emit(false)">Volver</button>
   </div>

  <div class="col-4 col-md-9 d-flex justify-content-end">
    <button class="btn btn-success text-white m-r-10" (click)="openModalAccount()">Agregar Concepto</button>
  </div>
</div>

<div [ngStyle]="{'top.px': contextMenu.y, 'left.px': contextMenu.x, 'position': 'absolute'}">
  <app-context-menu #contextMenu></app-context-menu>
</div>


<mat-table #table [dataSource]="dataSource" class="mat-elevation-z8" cdkDropListData="dataSource" cdkDropList (cdkDropListDropped)="drop($event)"
 >
  <ng-container matColumnDef="order">
    <mat-header-cell *matHeaderCellDef style="flex: 0 0 65px;">Orden </mat-header-cell>
    <mat-cell    *matCellDef="let element" style="flex: 0 0 65px;"  >
      <span ><i class="fa-solid fa-grip-vertical"></i></span>&nbsp;&nbsp;
      <span>{{element.order}}</span>
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="apsCode">
    <mat-header-cell *matHeaderCellDef style="flex: 0 0 130px;" > Cuenta en APS </mat-header-cell>
    <mat-cell *matCellDef="let element" (click)="enableEditing(element)" class="editable-span text-nowrap" style="flex: 0 0 130px;">
      @if(!element.isEditingapsCode){
      <span (click)="enableEditing(element,'apsCode')">
        {{ element.apsCode || '-' }}
      </span>
      }
      @if(element.isEditingapsCode&&element.isEditable){
      <input #input type="text" class="form-control form-control-sm" [value]="element.apsCode"
        (blur)="updateItemsAccount(element, 'apsCode', input.value);element.isEditingapsCode = false; element.apsCode = input.value"
        (keydown.enter)="updateItemsAccount(element, 'apsCode', input.value);element.isEditingapsCode = false; element.apsCode = input.value" />
      }
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="name">
    <mat-header-cell *matHeaderCellDef > Nombre para Mostrar </mat-header-cell>
    <mat-cell *matCellDef="let element" (click)="enableEditing(element)" class="editable-span text-nowrap">
      @if(!element.isEditingName){
      <span (click)="enableEditing(element,'Name')">
        {{ element.name || '-' }}
      </span>
      }
      @if(element.isEditingName&&element.isEditable){
      <input #input type="text" class="form-control form-control-sm" [value]="element.name"
        (blur)="updateItemsAccount(element, 'name', input.value);element.isEditingName = false; element.name = input.value"
        (keydown.enter)="updateItemsAccount(element, 'name', input.value);element.isEditingName = false; element.name = input.value" />
      }
    </mat-cell>
  </ng-container>
    <ng-container matColumnDef="decimalPlaces">
    <mat-header-cell *matHeaderCellDef > Decimales </mat-header-cell>
    <mat-cell *matCellDef="let element" (click)="enableEditing(element)" class="editable-span text-nowrap">
      @if(!element.isEditingdecimalPlaces){
      <span (click)="enableEditing(element,'decimalPlaces')">
        {{ element.decimalPlaces || '  -  ' }}
      </span>
      }
      @if(element.isEditingdecimalPlaces&&element.isEditable){
      <input #input type="text" class="form-control form-control-sm" [value]="element.decimalPlaces"
        (blur)="updateItemsAccount(element, 'decimalPlaces', input.value);element.isEditingdecimalPlaces = false; element.decimalPlaces = input.value"
        (keydown.enter)="updateItemsAccount(element, 'decimalPlaces', input.value);element.isEditingdecimalPlaces = false; element.decimalPlaces = input.value" />
      }
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="hint">
    <mat-header-cell *matHeaderCellDef >Info de Cuenta</mat-header-cell>
    <mat-cell *matCellDef="let element;let i =index" (click)="enableEditing(element,'Hint')" class="editable-span"
       >
      @if(!element.isEditingHint){
      <span>
        {{ element?.hint?.slice(0,60)|| '-' }}
      </span>
      }
      @if(element.isEditingHint&&element.isEditable){
      <div class="textarea-container">
        <textarea #input class="editable-textarea form-control form-control-sm" [value]="element.hint"
          (blur)="updateItemsAccount(element, 'hint', input.value); element.isEditingHint = false;element.hint=input.value"
          (keydown.enter)="updateItemsAccount(element, 'hint', input.value); element.isEditingHint = false;element.hint=input.value"
          (focus)="autoGrow($event)" (input)="autoGrow($event)" rows="1">
          </textarea>
      </div>
      }
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="accountCode" >
    <mat-header-cell *matHeaderCellDef style="flex: 0 0 130px;"> Cuenta Contable </mat-header-cell>
    <mat-cell *matCellDef="let element" (click)="enableEditing(element,'AccountCode')" class="editable-span text-nowrap"
      style="flex: 0 0 130px;" >
      @if(!element.isEditingAccountCode){
      <span (click)="enableEditing(element,'accountCode')">
        {{ element.accountCode || '-' }}
      </span>
      }
      @if(element.isEditingAccountCode&&element.isEditable){
      <input #input type="text" class="form-control form-control-sm" [value]="element.accountCode"
        (blur)="updateItemsAccount(element, 'accountCode', input.value);element.isEditingAccountCode = false; element.accountCode = input.value"
        (keydown.enter)="updateItemsAccount(element, 'accountCode', input.value);element.isEditingAccountCode = false; element.accountCode = input.value" />
      }
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="calculation">
    <mat-header-cell *matHeaderCellDef class="text-nowrap" > Formula</mat-header-cell>
    <mat-cell *matCellDef="let element;let i =index" (click)="openModalFormulaEditing(element)" class="editable-span"
      >
      @if(!element.isEditingCal){
      <span>
        {{ element?.calculation?.slice(0,60)|| '-' }}
      </span>
      }
     
    </mat-cell>
  </ng-container>
      <ng-container matColumnDef="syncAps">
    <mat-header-cell *matHeaderCellDef style="flex: 0 0 80px;"> Importar APS</mat-header-cell>
    <mat-cell *matCellDef="let element" style="flex: 0 0 80px;" >
      @if(element.isEditable){
      @if(element.apsCode&&element.apsCode!=''){
      <input #syncAps class="form-check-input" type="checkbox" [(ngModel)]="element.syncAps"
        (change)="syncEmployee(element,'syncAps',syncAps.checked)">
      }
      }
      </mat-cell>
  </ng-container>
    <ng-container matColumnDef="includeInTotal">
    <mat-header-cell *matHeaderCellDef style="flex: 0 0 80px;"> Mostar Total </mat-header-cell>
    <mat-cell *matCellDef="let element" style="flex: 0 0 80px;" >
      @if(element.isEditable){
      <input #includeInTotal class="form-check-input" type="checkbox" [checked]="element.includeInTotal"
        (change)="updateItemsAccount(element,'includeInTotal',includeInTotal.checked)">}</mat-cell>
      
  </ng-container>
  <ng-container matColumnDef="block">
    <mat-header-cell *matHeaderCellDef style="flex: 0 0 80px;"> Bloquear </mat-header-cell>
    <mat-cell *matCellDef="let element" style="flex: 0 0 80px;" >
      @if(element.isEditable){
      <input #block class="form-check-input" type="checkbox" [checked]="element.block"
        (change)="updateItemsAccount(element,'block',block.checked)">}</mat-cell>
  </ng-container>

 
  <ng-container matColumnDef="setting">
    <mat-header-cell *matHeaderCellDef style="flex: 0 0 100px;"> <i class="fa-solid fa-gear"></i></mat-header-cell>
    <mat-cell *matCellDef="let element" style="flex: 0 0 100px;" >
      @if(element.isEditable&&role?.level<=1){
       <button class="btn btn-outline-danger btn-xs" (click)="deleteItemsAccount(element)"><i
          class="fa-solid fa-trash"></i>
      </button>
      }@else {
        <i class="fa fa-info-circle" ngbTooltip="Configuración Unión"></i> 
      }
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns;" cdkDrag [cdkDragData]="row"></mat-row>
</mat-table>

<br>
}
@if(formulaEditing){
  <div class="row">
    <div class="col-12 col-md-6">
        <h1 class="page-header"><i class="fas fa-calculator"></i> {{formItemsTravel.get('code').value}} - {{formItemsTravel.get('name').value}}</h1>
  
    </div> 
    <div class="col-12 col-md-6">
      <div class=" d-md-flex fw-bold justify-content-end">
          <div class="mt-3">
            <a href="javascript:;" class="btn btn-sm btn-success me-2"
            (click)="submitEditItems()"><i
            class="fa fa-save fa-fw me-1"></i> Guardar</a>
                       <a href="javascript:;" class="btn btn-sm btn-outline-danger"
                       (click)="formulaEditing=false;resetForm()"><i
                              class="fa fa-times fa-fw me-1"></i> Cancelar</a>
                          
          </div>
      </div>
  </div>
     
  </div>
<div class="panel p-4 ">
    <form [formGroup]="formItemsTravel">
      <div class="table-data">
        <ngx-monaco-editor
          formControlName="calculation"
          [options]="editorOptions"
          (onInit)="onMonacoInit()" [container]="'body'">
        </ngx-monaco-editor>
      </div>
    </form>

</div>
}




<ng-template #modal_account let-c="close" let-d="dismiss" let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Agregar Concepto</h5>
    <button (click)="d('Cross click')" type="button" class="btn-close bt-xs" data-dismiss="modal" tabindex="7">
      <span></span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="formItemsTravel">
      <div class="form-group row">
        <label class="col-md-4 col-form-label">Código</label>
        <div class="col-md-8">
          <input type="text" #nameInput
          [class.is-invalid]="formItemsTravel.get('code').invalid&&formItemsTravel.get('code').touched"
          (click)="formItemsTravel.get('code').markAsUntouched();"
          (focus)="formItemsTravel.get('code').markAsUntouched();" formControlName="code"
          name="code" class="form-control" tabindex="1" />
          
          @if(formItemsTravel.get('code')?.errors?.required &&
          formItemsTravel.get('code').touched){
          <div><small class="text-danger">Código es requerido.</small></div>
          }
        </div>
      </div>&nbsp;
      <div class="form-group row">
        <label class="col-md-4 col-form-label">Nombre para mostrar</label>
        <div class="col-md-8">
          <input type="text" #nameInput
            [class.is-invalid]="formItemsTravel.get('name').invalid&&formItemsTravel.get('name').touched"
            (click)="formItemsTravel.get('name').markAsUntouched();"
            (focus)="formItemsTravel.get('name').markAsUntouched();" formControlName="name"
            name="name" class="form-control" tabindex="2" />
          @if(formItemsTravel.get('name')?.errors?.required &&
          formItemsTravel.get('name').touched){
          <div><small class="text-danger">Campo es requerido.</small></div>
          }
        </div>
      </div>&nbsp;
      <div class="form-group row">
        <label class="col-md-4 col-form-label">Inf Campo</label>
        <div class="col-md-8">
          <input type="text"
            [class.is-invalid]="formItemsTravel.get('hint').invalid&&formItemsTravel.get('hint').touched"
            (click)="formItemsTravel.get('hint').markAsUntouched();"
            (focus)="formItemsTravel.get('hint').markAsUntouched();" formControlName="hint" name="hint"
            class="form-control" tabindex="2" />
          @if(formItemsTravel.get('hint')?.errors?.required && formItemsTravel.get('hint').touched){
          <div><small class="text-danger">Campo es requerido.</small></div>
          }
        </div>
      </div>&nbsp;
      <div class="form-group row">
        <label class="col-md-4 col-form-label">Cuenta Contable</label>
        <div class="col-md-8">
          <input type="text"
            [class.is-invalid]="formItemsTravel.get('accountCode').invalid&&formItemsTravel.get('accountCode').touched"
            (click)="formItemsTravel.get('accountCode').markAsUntouched();"
            (focus)="formItemsTravel.get('accountCode').markAsUntouched();" formControlName="accountCode" name="accountCode"
            class="form-control" tabindex="3" />
          @if(formItemsTravel.get('accountCode')?.errors?.required && formItemsTravel.get('accountCode').touched){
          <div><small class="text-danger">Campo es requerido.</small></div>
          }
        </div>
      </div>&nbsp;
      <div class="form-group row">
        <label class="col-md-4 col-form-label">Formula</label>
        <div class="col-md-8">
          <textarea #input formControlName="calculation" name="calculation" class="form-control form-control-sm"
            (focus)="autoGrow($event)" (input)="autoGrow($event)" rows="1">
        </textarea>
        </div>
      </div>

    </form>
  </div>
  <div class="modal-footer">
    @if(formItemsTravel.errors){
    <div><small class="text-danger">{{formItemsTravel.errors | json }}</small></div>
    }
    <button type="button" class="btn btn-secondary btn-sm" (click)="d('Cross click'); resetForm()"><i
        class="fas fa-times"></i>&nbsp; Cerrar</button>
    <button type="button" class="btn btn-primary btn-sm" (click)="submitNewItems()"
      
      tabindex="4"><i class="fas fa-save"></i>&nbsp;Guardar</button>


  </div>

</ng-template>